import type { LayoutLoad } from './$types';
			import type { CategoryData } from '$lib/metadataTypes/MetaTypes';
			
			export const load: LayoutLoad = async ({ parent }): Promise<CategoryData> => {
				const { site } = await parent(); // parent() = SiteData
				return {
					site,
					category: {
							title: "Freon Tutorials — Learn to Build Your Own DSL Step by Step",
description: "Follow hands-on tutorials that guide you through creating domain-specific languages (DSLs) with the Freon Language Workbench, from defining metamodels to building a web-based projectional editor.",
tags: [ "tutorials", "getting started", "DSL development", "metamodel", "projectional editor", "TypeScript", "Svelte", "language workbench"] 
					}
				};
			};